import { Navigation } from "@/constants";
import { SimplePage } from "@/app/_/marketing/SimplePage";

export default function Page() {
  return (
    <SimplePage
      eyebrow="Platform"
      title="Multi-entity, agentic accounting."
      subtitle="Neoledger combines an AI-native agent layer with triage, configurable reports, and a full ledger — so finance teams can review, automate, and report without switching tools."
      secondaryCta={{
        label: "Book a demo",
        to: Navigation.ROUTES.AUTH.WAITLIST,
      }}
      screenshot={{
        imageName: "reports-dashboard",
        alt: "A live dashboard across four entities",
      }}
      bullets={Navigation.PLATFORM_ITEMS.map((item) => ({
        ReactIcon: item.ReactIcon,
        name: item.name,
        tagline: item.tagline,
        to: item.path,
      }))}
    />
  );
}
